<template>
  <div id="accounts-payable-transhipment">
    <BreadCrumb :items="breadcrumbItems" />
    <br />
    <v-card elevation="1" class="pt-5 mt-1">
      <div class="header d-flex justify-space-between pr-5 align-center">
        <h1 class="pl-0 ml-5">Transbordos a pagar</h1>
        <div class="d-flex">
          <v-tooltip top :disabled="!shouldDisableReceiptManagement">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-btn
                  :disabled="shouldDisableReceiptManagement"
                  class="mx-2"
                  elevation="2"
                  color="info"
                  large
                  @click="handleRedirectSelectedToReceiptsManagement()"
                  :loading="isReceiptManagementButtonLoading"
                >
                  Gerenciar Canhotos
                </v-btn>
              </div>
            </template>
            <span>Selecione ao menos uma carga ou parada</span>
          </v-tooltip>
          <v-btn
            :disabled="selectedCheckbox.length == 0"
            :loading="isOpenLoading"
            elevation="2"
            color="success"
            large
            @click="openDialog()"
            >CRIAR ORDEM DE PAGAMENTO</v-btn
          >
        </div>
      </div>

      <v-expansion-panels class="px-5 py-1 mt-2" accordion>
        <v-expansion-panel class="elevation-1">
          <v-expansion-panel-header color="#f2f2f2" class="px-4">
            <span>Filtrar por</span>
            <template v-slot:actions>
              <v-icon color="black"> mdi-chevron-down </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-2 pb-1">
              <v-col cols="12" md="3">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedDate"
                      label="Data de Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    :active-picker.sync="activePicker"
                    @change="save1"
                    locale="pt-br"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <v-menu
                  ref="menu"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndDate"
                      label="Data de Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date1"
                    :active-picker.sync="activePicker1"
                    @change="save2"
                    locale="pt-br"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="transhipmentId"
                  :items="transhipments"
                  label="Transbordo"
                  item-text="name"
                  item-value="id"
                  class="auto-complete"
                  @change="saveTranshipment()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="CTENumber" label="Número CTE" @change="saveCteNumber()"></v-text-field>
              </v-col>

              <v-col cols="12" md="12" class="d-flex justify-end align-center">
                <v-btn
                  :disabled="!hasFilters"
                  elevation="2"
                  color="red"
                  class="mx-2"
                  :dark="hasFilters"
                  @click="cleanFilter()"
                >
                  Limpar Filtros
                </v-btn>
                <v-btn
                  :loading="isTranshipmentLoading"
                  :disabled="!hasFilters"
                  :dark="hasFilters"
                  elevation="2"
                  color="green"
                  @click="search()"
                >
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="table mt-10 p-relative">
        <table-title-row :columnsOptions="columnOptions"></table-title-row>
        <v-progress-linear v-if="isTranshipmentLoading" indeterminate color="primary"></v-progress-linear>
        <div v-if="nodes.length != 0">
          <template v-for="(node, nodeIndex) in nodes">
            <div :key="node.data.id">
              <table-body-row
                :checkboxDisabled="!node.hasSelectedChildren && selectedCheckbox.length > 0"
                :node="node"
                :nodeIndex="nodeIndex"
                :columns="columns"
                :lengthDataToTruncate="30"
                type="TransbordoAccounts"
                enableCheckbox
                :selectedCheckbox="selectedCheckbox"
                @onExpand="onExpand(node)"
                @changeCheckbox="changeSelectedCheckbox"
                @click="setTranshipmentSelected(node.data.id)"
              >
              </table-body-row>
              <v-row v-if="node.open" style="margin-top: 0">
                <v-progress-linear
                  v-if="loadingTranshipmentKey === nodeIndex && isCargoLoading"
                  class="mx-3"
                  indeterminate
                  color="primary"
                ></v-progress-linear>

                <v-col cols="12" class="mb-4">
                  <v-card>
                    <v-card-text class="p-5">
                      <table-title-row :columnsOptions="columnsCargoOptions">
                        <template #stops>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-on="on" v-bind="attrs" size="15" style="cursor: pointer"
                                >mdi-help-circle-outline</v-icon
                              >
                            </template>
                            <div class="d-flex flex-column">
                              <span><v-icon dark> mdi-truck-fast-outline</v-icon> - Em andamento</span>
                              <span><v-icon dark> mdi-truck-check</v-icon> - Finalizadas</span>
                              <span><v-icon dark> mdi-calendar</v-icon> - Programadas</span>
                              <span><v-icon dark> mdi-cash</v-icon> - Pagas</span>
                              <span><v-icon dark> mdi-alpha-t</v-icon> - Total de paradas</span>
                            </div>
                          </v-tooltip>
                        </template>
                      </table-title-row>
                      <template v-for="(cargo, cargoIndex) in node.children">
                        <div :key="cargo.data.id">
                          <table-body-row
                            :checkboxDisabled="!node.hasSelectedChildren && selectedCheckbox.length > 0"
                            :node="cargo"
                            :nodeIndex="cargoIndex"
                            :columns="columnsCargo"
                            :lengthDataToTruncate="40"
                            type="CargaAccounts"
                            enableCheckbox
                            :selectedCheckbox="selectedCheckbox"
                            @changeCheckbox="changeSelectedCheckbox"
                            @onExpand="onExpandCargo(cargo)"
                            @click="setTranshipmentSelected(node.data.id)"
                          >
                            <template #cargo-stop-details>
                              <div class="d-flex" style="gap: 4px">
                                <span class="d-flex align-center font-weight-bold">
                                  <v-icon size="20" class="pr-2"> mdi-truck-fast-outline</v-icon>
                                  {{ cargo.data.inProgress }}</span
                                >
                                <span class="d-flex align-center font-weight-bold">
                                  <v-icon size="20" class="px-2"> mdi-truck-check</v-icon>
                                  {{ cargo.data.finished }}</span
                                >
                                <span class="d-flex align-center font-weight-bold">
                                  <v-icon size="18" class="px-2"> mdi-calendar</v-icon>
                                  {{ cargo.data.scheduled }}</span
                                >
                                <span class="d-flex align-center font-weight-bold">
                                  <v-icon size="22" class="px-2"> mdi-cash</v-icon>
                                  {{ cargo.data.paid }}</span
                                >
                                <span class="d-flex align-center font-weight-bold">
                                  <v-icon size="24" class="pr-1"> mdi-alpha-t</v-icon>
                                  {{ cargo.data.totalStopsOfALoad }}</span
                                >
                              </div>
                            </template>
                          </table-body-row>

                          <v-row v-if="cargo.open" style="margin-top: 0">
                            <v-progress-linear
                              v-if="loadingCargoKey === cargoIndex && isStopsLoading"
                              class="mx-3"
                              indeterminate
                              color="primary"
                            ></v-progress-linear>
                            <v-col cols="12" class="mb-4">
                              <v-card>
                                <v-card-text class="p-5">
                                  <table-title-row :columnsOptions="columnsStopsOptions"></table-title-row>
                                  <template v-for="(stop, stopsIndex) in cargo.children">
                                    <div :key="stop.data.id">
                                      <table-body-row
                                        :checkboxDisabled="!node.hasSelectedChildren && selectedCheckbox.length > 0"
                                        :node="stop"
                                        :nodeIndex="stopsIndex"
                                        :columns="columnsStops"
                                        :lengthDataToTruncate="30"
                                        type="ParadaAccounts"
                                        enableCheckbox
                                        :selectedCheckbox="selectedCheckbox"
                                        @changeCheckbox="changeSelectedCheckbox"
                                        @onExpand="onExpandStop(stop)"
                                        @click="setTranshipmentSelected(node.data.id)"
                                        @receiptFlagClick="handleRedirectToReceiptsManagement(stop.data)"
                                      >
                                        <template #price="{ item }">{{ transformPrice(item) }}</template>
                                      </table-body-row>

                                      <Status :nodeIndex="stopsIndex" :status="stop.data.stopStatus" />

                                      <v-row v-if="stop.open" style="margin-top: 0">
                                        <v-progress-linear
                                          v-if="loadingStopKey === stopsIndex && isNfesLoading"
                                          class="mx-3"
                                          indeterminate
                                          color="primary"
                                        ></v-progress-linear>

                                        <v-col cols="12" class="mb-4">
                                          <v-card>
                                            <v-card-text class="p-5">
                                              <table-title-row :columnsOptions="columnsNfesOptions"></table-title-row>
                                              <template v-for="(nfe, nfeIndex) in stop.children">
                                                <div :key="nfe.data.id">
                                                  <table-body-row
                                                    :node="nfe"
                                                    :nodeIndex="nfeIndex"
                                                    :columns="columnsNfes"
                                                    :lengthDataToTruncate="30"
                                                    type="Nota Fiscal"
                                                    :enableDropdown="true"
                                                    :itemsDropdown="itemsDropdownNfe"
                                                    @actionsDropdown="actionsDropdownNfe"
                                                    @receiptFlagClick="handleRedirectToReceiptsManagementNfe(nfe.data)"
                                                  >
                                                  </table-body-row>

                                                  <Status :nodeIndex="nfeIndex" :status="nfe.data.nfeStatus" />
                                                </div>
                                              </template>
                                            </v-card-text>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </template>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </template>
        </div>
        <div class="table mt-10 p-relative" v-else>Nenhum transbordo com entrega finalizada foi encontrado</div>
        <div class="mt50"></div>
        <div class="d-flex justify-space-between">
          <v-pagination
            v-model="pageNumber"
            :length="totalPages"
            total-visible="7"
            @input="fetchAllAccountsTranshipment"
          ></v-pagination>
        </div>
      </div>
    </v-card>

    <PaymentOrder
      :open="paymentOrder"
      @closePaymentOrder="closeDialog"
      :selectedFather="selectedTranshipment"
      :selectedItems="selectedStops"
      :transhipmentAllItems="fatherAllItems"
      transhipment
    />

    <HistoricNfe :id="nfeSelectedId" :open="isOpenHistoryNfe" @closeHistoricNfe="isOpenHistoryNfe = false" />

    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import PaymentOrder from '@/components/AccountsPayable/PaymentOrder.vue';
import BreadCrumb from '@/components/BreadCrumb.vue';

import TableTitleRow from '@/components/Table/Table-Title-Row.vue';
import TableBodyRow from '@/components/Table/Table-Body-Row.vue';
import Status from '@/components/Table/Status.vue';
import HistoricNfe from '@/components/Nfe/HistoricNfe.vue';

import changeCheckbox from '@/utils/changeSelectedCheckbox';
import maskData from '@/utils/maskData';
import maskPrice from '@/utils/maskPrice';
import maskCNPJ from '@/utils/maskCNPJ';
import MessagesError from '@/components/MessagesError.vue';

export default {
  name: 'AccountsPayableTranshipment',
  components: {
    BreadCrumb,
    PaymentOrder,
    TableTitleRow,
    TableBodyRow,
    Status,
    HistoricNfe,
    MessagesError
  },
  data: () => ({
    pageNumber: 0,
    totalPages: 0,
    isReceiptManagementButtonLoading: false,
    isCargoLoading: false,
    isStopsLoading: false,
    isNfesLoading: false,
    isTranshipmentLoading: false,
    loadingTranshipmentKey: null,
    isOpenHistoryNfe: false,
    nfeSelectedId: null,
    loadingCargoKey: null,
    loadingStopKey: null,
    isOpenLoading: false,
    selectedCheckbox: [],
    selectedStops: [],
    selectedTranshipment: {
      children: [],
      data: { name: '' }
    },
    nodes: [],
    columns: ['name', 'actions'],
    columnsCargo: ['id', 'number', 'stillHaveToPay', 'amountPaid', 'stops', 'actions'],
    columnsStops: [
      'id',
      'numbersCte',
      'createdAt',
      'recipientName',
      'recipientCPFOrCNPJ',
      'cityName',
      'displayPrice',
      'canhotoType',
      'actions'
    ],
    columnsStopsOptions: [
      {
        value: 'id',
        text: 'ID PARADAS CONCLUÍDAS'
      },
      {
        value: 'numbersCte',
        text: 'NÚMEROS DE CTES'
      },
      {
        value: 'createdAt',
        text: 'DATA DE CRIAÇÃO DO EMBARQUE'
      },
      {
        value: 'recipientName',
        text: 'DESTINATÁRIO'
      },
      {
        value: 'recipientCPFOrCNPJ',
        text: 'CNPJ DO DESTINATÁRIO'
      },
      {
        value: 'cityName',
        text: 'CIDADE'
      },
      {
        value: 'displayPrice',
        text: 'VALOR'
      },
      {
        value: 'canhotoType',
        text: 'STATUS DO CANHOTO'
      },
      {
        value: 'actions',
        text: 'AÇÕES'
      }
    ],
    columnsNfes: ['type', 'number', 'price', 'completionDate', 'canhotoType', 'actions'],
    columnsNfesOptions: [
      {
        value: 'type',
        text: 'TIPO'
      },
      {
        value: 'number',
        text: 'NÚMERO NFE'
      },
      {
        value: 'price',
        text: 'PREÇO DA NF'
      },
      {
        value: 'completionDate',
        text: 'DATA DE CONCLUSÃO'
      },
      {
        value: 'canhotoType',
        text: 'STATUS DO CANHOTO'
      },
      {
        value: 'actions',
        text: 'Ações'
      }
    ],
    loading: false,
    paymentOrder: false,
    transhipments: [],
    paymentForecast: null,
    date: null,
    date1: null,
    date2: null,
    CTENumber: null,
    transhipmentId: null,
    menu: false,
    menu1: false,
    menu2: false,
    errors: [],
    error500: null,
    errorsType: 'error',
    activePicker: null,
    activePicker1: null,
    activePicker2: null,
    fatherAllItems: [],
    transhipmentSelected: '',
    itemsDropdownNfe: [{ title: 'Histórico' }],
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Financeiro',
        disabled: true,
        to: '/couriers-accounts-payable/'
      },
      {
        text: 'Transbordos',
        disabled: true,
        to: '/couriers-accounts-payable/'
      }
    ],
    columnOptions: [
      {
        value: 'courier',
        text: 'TRANSBORDO'
      }
    ],
    columnsCargoOptions: [
      {
        value: 'id',
        text: 'ID DA CARGA'
      },
      {
        value: 'number',
        text: 'NÚMERO EXTERNO DO EMBARQUE'
      },
      {
        value: 'stillHaveToPay',
        text: 'FALTA PAGAR'
      },
      {
        value: 'amountPaid',
        text: 'QUANTIDADE PAGO'
      },
      {
        value: 'stops',
        text: 'PARADAS'
      },

      {
        value: 'actions',
        text: 'AÇÕES'
      }
    ]
  }),
  computed: {
    ...mapState('AccountsStore', ['paginate']),
    ...mapGetters('ShipmentStore', ['getManegementShipments']),
    ...mapGetters('AccountsStore', ['getAllTranshipments']),
    ...mapGetters('NfeStore', ['getSelectedChecbox']),

    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);
      }
    },
    hasFilters() {
      if (this.date || this.date1 || this.CTENumber || this.transhipmentId) {
        return true;
      }
      return false;
    },

    shouldDisableReceiptManagement() {
      return !this.nodes.some((node) => {
        return node.open && node.hasSelectedChildren;
      });
    },
    formattedDate() {
      if (!this.date) return '';
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndDate() {
      if (!this.date1) return '';
      const [year, month, day] = this.date1.split('-');
      return `${day}/${month}/${year}`;
    },

    getTheLastThirtyDays() {
      const now = new Date();
      const currentDay = now;
      const thirtyDayAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);

      return {
        thirtyDayAgo: thirtyDayAgo.toISOString().slice(0, 10),
        currentDay: currentDay.toISOString().slice(0, 10)
      };
    }
  },

  watch: {
    pageNumber: {
      handler() {
        this.selectedCheckbox = [];
      }
    }
  },

  created() {
    this.clearTranshipmentAccountsFilters();
    this.resetManegementFilters();
  },
  mounted() {
    this.filterTheLastThirtyDays();
    this.fetchSummaryTranshipments();
    this.fetchAllAccountsTranshipment();
  },
  methods: {
    ...mapActions('AccountsStore', [
      'fetchTranshipment',
      'fetchStopsByTranshipmentId',
      'fetchCargosByTranshipmentId',
      'getStopsWithoutPaymentOrderByTranshipmentId'
    ]),
    ...mapActions('TranshipmentStore', ['getSummaryDataTranshipment']),
    ...mapMutations('AccountsStore', [
      'setFiltersTranshipmentTranshipmentId',
      'setFiltersTranshipmentCteNumber',
      'setFiltersTranshipmentCreatedAtStart',
      'setFiltersTranshipmentCreatedAtEnd'
    ]),
    ...mapMutations('NfeStore', ['setSelectedCheckbox']),
    ...mapActions('NfeStore', ['fetchNfesByStopId']),
    ...mapMutations('ShipmentStore', ['resetManegementFilters']),

    async fetchSummaryTranshipments() {
      this.loading = true;
      try {
        this.transhipments = await this.getSummaryDataTranshipment();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async handleRedirectSelectedToReceiptsManagement() {
      const cargosNode = this.nodes.find((node) => node.hasSelectedChildren).children;
      const selectedCargos = cargosNode.filter((cargoNode) => cargoNode.selected);
      let stopsFromUnexpandedCargos = [];
      try {
        this.isReceiptManagementButtonLoading = true;

        for (let cargoNode of selectedCargos) {
          if (!cargoNode.children.length) {
            const data = await this.fetchStopsByTranshipmentId(cargoNode.data.id);
            stopsFromUnexpandedCargos = [
              ...stopsFromUnexpandedCargos,
              ...data.map((stop) => {
                return { ...stop, type: 'Stop' };
              })
            ];
          }
        }
        const selectedStops = this.selectedCheckbox.filter((item) => item.type === 'Stop');
        const stopsToFetchReceipts = [...selectedStops, ...stopsFromUnexpandedCargos];

        this.setSelectedCheckbox(stopsToFetchReceipts);
        window.open('#/shipments/receipts');
      } catch (error) {
        console.error(error);
      } finally {
        this.isReceiptManagementButtonLoading = false;
      }
    },
    handleRedirectToReceiptsManagement(stop) {
      this.setSelectedCheckbox([stop]);
      window.open('#/shipments/receipts');
    },
    handleRedirectToReceiptsManagementNfe(nfe) {
      this.setSelectedCheckbox([nfe]);
      window.open('#/shipments/receipts', '_blank');
    },
    transformDateToISOString(date) {
      this.$refs.menu.save(date);
      const partOfDate = date.split('-');
      const newDate = new Date(partOfDate[0], partOfDate[1] - 1, partOfDate[2]);
      return newDate.toISOString();
    },
    save1(date) {
      const newDate = this.transformDateToISOString(date);
      this.setFiltersTranshipmentCreatedAtStart(newDate);

      this.search();
    },
    save2(date) {
      const newDate = this.transformDateToISOString(date);
      this.setFiltersTranshipmentCreatedAtEnd(newDate);

      this.search();
    },
    saveCteNumber() {
      this.setFiltersTranshipmentCteNumber(this.CTENumber);

      this.search();
    },
    saveTranshipment() {
      this.setFiltersTranshipmentTranshipmentId(this.transhipmentId);

      this.search();
    },
    cleanFilter() {
      this.date = null;
      this.date1 = null;
      this.CTENumber = null;
      this.transhipmentId = null;

      this.setFiltersTranshipmentTranshipmentId(null);
      this.setFiltersTranshipmentCteNumber(null);
      this.setFiltersTranshipmentCreatedAtStart(null);
      this.setFiltersTranshipmentCreatedAtEnd(null);

      this.fetchAllAccountsTranshipment();
    },
    clearTranshipmentAccountsFilters() {
      this.setFiltersTranshipmentTranshipmentId(null);
      this.setFiltersTranshipmentCteNumber(null);
      this.setFiltersTranshipmentCreatedAtStart(null);
      this.setFiltersTranshipmentCreatedAtEnd(null);
    },
    search() {
      this.fetchAllAccountsTranshipment();
    },
    closeDialog(hasChange, message) {
      this.paymentOrder = false;
      if (hasChange) {
        this.fetchAllAccountsTranshipment();
      }
      if (message) {
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
      }
    },

    setTranshipmentSelected(transhipmentId) {
      this.transhipmentSelected = transhipmentId;
    },

    hasTranshipmentsSelected(array) {
      return array.some((array) => array.type === 'Transhipment');
    },
    hasCargoSelected(array) {
      return array.some((array) => array.type === 'Cargo');
    },
    hasStopsSelected(array) {
      return array.some((array) => array.type === 'Stop');
    },

    async openDialog() {
      this.selectedStops = [];
      this.fatherAllItems = [];
      this.isOpenLoading = true;

      const data = await this.getStopsWithoutPaymentOrderByTranshipmentId(this.transhipmentSelected);
      this.fatherAllItems = this.mapAllFatherAllItems(data);

      if (this.hasTranshipmentsSelected(this.selectedCheckbox)) {
        this.selectedStops = data;
      } else if (this.hasCargoSelected(this.selectedCheckbox)) {
        const cargoIds = this.selectedCheckbox
          .filter((selected) => {
            if (selected.type === 'Cargo') return selected;
          })
          .map((selectedFiltered) => selectedFiltered.id);
        let stops = [];

        await Promise.all(
          cargoIds.map(async (cargoId) => {
            const data = await this.fetchStopsByTranshipmentId(cargoId);
            stops = [...stops, ...data];
          })
        );

        if (this.hasStopsSelected(this.selectedCheckbox)) {
          const stopsFiltered = this.selectedCheckbox
            .filter((selected) => selected.type === 'Stop')
            .filter((stop) => {
              const stopsIds = stops.map((stop) => stop.id);
              if (!stopsIds.includes(stop.id)) {
                return stop;
              }
            });
          stops = [...new Set([...stops, ...stopsFiltered])];
        }

        this.selectedStops = stops;
      } else {
        this.selectedStops = this.selectedCheckbox.filter((selected) => selected.type === 'Stop');
      }

      this.isOpenLoading = false;
      this.paymentOrder = true;
    },
    mapAllFatherAllItems(stops) {
      return stops.map((item, index) => {
        return {
          key: index,
          data: {
            ...item,
            createdAt: this.transformDate(item.createdAt),
            recipientCPFOrCNPJ: this.transformCNPJ(item.recipientCPFOrCNPJ),
            displayPrice: this.transformPrice(item.price),
            canhotoType: item.missingReceipt ? '1' : !item.receiptValidated ? '2' : '3',
            type: 'Stop'
          },
          selected: false,
          type: 'AccountsPayableTranshipmentStop'
        };
      });
    },
    async fetchUnselectedItems(idNode) {
      const fatherItems = await this.getStopsWithoutPaymentOrderByTranshipmentId(this.nodes[idNode].data.id);
      const newShipments = fatherItems.map((item, index) => {
        return {
          key: index,
          data: {
            ...item,
            createdAt: this.transformDate(item.createdAt),
            recipientCPFOrCNPJ: this.transformCNPJ(item.recipientCPFOrCNPJ),
            displayPrice: this.transformPrice(item.price),
            canhotoType: item.missingReceipt ? '1' : !item.receiptValidated ? '2' : '3',
            type: 'Stop'
          },
          selected: false,
          type: 'AccountsPayableTranshipmentStop'
        };
      });
      return newShipments;
    },
    async fetchAllAccountsTranshipment() {
      this.isTranshipmentLoading = true;
      try {
        const { pageNumber } = this;
        const filters = this.getFilters();
        await this.fetchTranshipment({ pageNumber, pageSize: 10, ...filters });
        const { data, pageNumber: newPageNumber, totalPages } = this.getAllTranshipments;
        this.pageNumber = newPageNumber;
        this.totalPages = totalPages;
        const newShipments = data.map((item, index) => {
          return {
            key: index,
            data: {
              ...item,
              type: 'Transhipment'
            },
            children: [],
            type: 'AccountsPayableTranshipmentFather',
            open: false,
            selected: false,
            hasSelectedChildren: false
          };
        });

        this.nodes = newShipments;
      } catch (err) {
        console.error(err);
      } finally {
        this.isTranshipmentLoading = false;
        setTimeout(() => {
          this.selectedCheckbox = [];
        }, 0);
      }
    },

    filterTheLastThirtyDays() {
      const { thirtyDayAgo, currentDay } = this.getTheLastThirtyDays;
      this.date = thirtyDayAgo;
      this.date1 = currentDay;
    },

    async fetchCargosById(selected) {
      try {
        this.isCargoLoading = true;
        const data = await this.fetchCargosByTranshipmentId(selected.data.id);
        const newShipments = data.map((item, index) => {
          return {
            key: selected.key + '-' + index,
            data: {
              ...item,
              stillHaveToPay: this.transformPrice(item.stillHaveToPay),
              amountPaid: this.transformPrice(item.amountPaid),
              type: 'Cargo'
            },
            selected: false,
            type: 'AccountsPayableTranshipmentCargo',
            children: [],
            open: false,
            hasSelectedChildren: false
          };
        });

        this.nodes[selected.key].children = newShipments;

        if (selected.selected) {
          this.nodes[selected.key].children.map((item) => {
            item.selected = true;
            if (!this.selectedCheckbox.includes(item.data)) {
              this.selectedCheckbox.push(item.data);
            }
          });
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isCargoLoading = false;
        this.loading = false;
      }
    },

    async fetchStopsById(selected) {
      const idNode = Number(selected.key.split('-')[0]);
      const idCargo = Number(selected.key.split('-')[1]);
      try {
        this.isStopsLoading = true;
        const data = await this.fetchStopsByTranshipmentId(selected.data.id);
        const newShipments = data.map((item, index) => {
          return {
            key: idNode + '-' + idCargo + '-' + index,
            data: {
              ...item,
              createdAt: this.transformDate(item.createdAt),
              recipientCPFOrCNPJ: this.transformCNPJ(item.recipientCPFOrCNPJ),
              displayPrice: this.transformPrice(item.price),
              canhotoType: item.missingReceipt ? '1' : !item.receiptValidated ? '2' : '3',
              type: 'Stop'
            },
            children: [],
            selected: false,
            open: false,
            type: 'AccountsPayableTranshipmentStop'
          };
        });

        this.nodes[idNode].children[idCargo].children = newShipments;

        if (selected.selected) {
          this.nodes[idNode].children[idCargo].children.map((item) => {
            item.selected = true;
            if (!this.selectedCheckbox.includes(item.data)) {
              this.selectedCheckbox.push(item.data);
            }
          });
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isStopsLoading = false;
        this.loading = false;
      }
    },

    async fetchNfesByStop(selected) {
      const idNode = Number(selected.key.split('-')[0]);
      const idCargo = Number(selected.key.split('-')[1]);
      const idStop = Number(selected.key.split('-')[2]);

      try {
        this.isNfesLoading = true;
        const data = await this.fetchNfesByStopId(selected.data.id);
        const newNfes = data.map((item, index) => {
          return {
            key: idNode + '-' + idCargo + '-' + idStop + '-' + index,
            data: {
              ...item,
              completionDate: this.transformDate(item.completionDate),
              price: this.transformPrice(item.price),
              canhotoType: item.missingReceipt ? '1' : !item.receiptValidated ? '2' : '3',
              type: 'Nota Fiscal'
            },
            selected: false,
            type: 'AccountsPayableTranshipmentNfe'
          };
        });

        this.nodes[idNode].children[idCargo].children[idStop].children = newNfes;
      } catch (err) {
        console.error(err);
      } finally {
        this.isNfesLoading = false;
        this.loading = false;
      }
    },

    async onExpand(selected) {
      this.loadingTranshipmentKey = selected.key;
      this.nodes[selected.key].open = !this.nodes[selected.key].open;
      if (selected.children.length === 0) {
        this.fetchCargosById(selected);
      }
    },

    async onExpandCargo(selected) {
      const idNode = Number(selected.key.split('-')[0]);
      const idCargo = Number(selected.key.split('-')[1]);
      this.loadingCargoKey = idCargo;

      this.nodes[idNode].children[idCargo].open = !this.nodes[idNode].children[idCargo].open;
      if (selected.children.length === 0) {
        this.fetchStopsById(selected);
      }
    },

    async onExpandStop(selected) {
      const idNode = Number(selected.key.split('-')[0]);
      const idCargo = Number(selected.key.split('-')[1]);
      const idStop = Number(selected.key.split('-')[2]);
      this.loadingStopKey = idStop;

      this.nodes[idNode].children[idCargo].children[idStop].open =
        !this.nodes[idNode].children[idCargo].children[idStop].open;
      if (selected.children.length === 0) {
        this.fetchNfesByStop(selected);
      }
    },

    changeSelectedCheckbox(item, children) {
      if (item.type === 'AccountsPayableTranshipmentStop') {
        const courierKey = item.key.split('-')[0];
        const cargoKey = item.key.split('-')[1];
        this.selectedTranshipment = this.nodes[courierKey];

        this.selectedCheckbox = changeCheckbox(
          this.selectedCheckbox,
          item,
          children,
          cargoKey,
          0,
          0,
          this.nodes[courierKey]
        );
      } else if (item.type === 'AccountsPayableTranshipmentCargo') {
        const courierKey = item.key.split('-')[0];
        this.selectedTranshipment = this.nodes[courierKey];

        this.selectedCheckbox = changeCheckbox(this.selectedCheckbox, item, children, 0, 0, 0, this.nodes[courierKey]);
      } else {
        this.selectedTranshipment = this.nodes[item.key];
        this.selectedCheckbox = changeCheckbox(this.selectedCheckbox, item, children);
      }
    },
    async checkIfTranshipmentChildrenIsSelected(transhipmentNode) {
      if (this.selectedCheckbox.length > 0) {
        this.selectedCheckbox = [];

        if (transhipmentNode === null) return;
        if (transhipmentNode.children.length > 0) {
          return;
        }

        const data = await this.getStopsWithoutPaymentOrderByTranshipmentId(transhipmentNode.data.id);
        data.forEach((element) => this.selectedCheckbox.push(element));
      }
    },
    async checkIfCargoChildrenIsSelected(cargoNode) {
      if (this.selectedCheckbox.length > 0) {
        if (cargoNode.length === 0) return;
        await cargoNode.forEach((element) => {
          if (element.children.length < 1) {
            this.fetchStopsById(element);
          }
        });
      }
    },

    actionsDropdownNfe(index, node) {
      this.nfeSelectedId = node.data.id;
      if (index === 0) {
        this.isOpenHistoryNfe = true;
      }
    },

    getFilters() {
      const { date, date1, transhipmentId, CTENumber } = this;
      return { date, date1, transhipmentId, CTENumber };
    },

    save(date) {
      this.$refs.menu.save(date);
      const partOfDate = date.split('-');
      const newDate = new Date(partOfDate[0], partOfDate[1] - 1, partOfDate[2]);
      console.log(newDate);
    },
    transformDate(date) {
      return maskData(date);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    transformCNPJ(str) {
      if (str.length === 14 || str.length === 11) {
        return maskCNPJ(str);
      }

      return str;
    }
  }
};
</script>
<style scoped lang="scss"></style>
